import {useMemo} from 'react';
import { useSelector } from 'react-redux';

const selectInvalidFields = state => state.requiredUserActions.invalidFields;
export function useInvalidFields() {
    return useSelector(selectInvalidFields);
}
